import React, { useState } from 'react';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '../../../../../constants';
import { TESTIMONIALS_DATA } from './constants';
import { TestimonialCard } from './components/testimonial-card';
import {
  NavigationButtons,
  MobileNavigationButtons,
  RightNavigationButton,
} from './components/navigation-buttons';

const QuotationSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(2); // Middle one active by default (index 2 out of 0-5)

  // Navigation is always circular — no disabled state
  const handleScrollClick = (direction: 'left' | 'right') => {
    const total = TESTIMONIALS_DATA.length;
    if (direction === 'left') {
      setActiveIndex((prev) => (prev - 1 + total) % total);
    } else {
      setActiveIndex((prev) => (prev + 1) % total);
    }
  };

  // Get current testimonial
  const currentTestimonial = TESTIMONIALS_DATA[activeIndex];

  return (
    <section className={clsx(
      'w-full overflow-hidden',
      'bg-bg-primaryMedium',
      'py-7 md:py-9 lg:py-10'
    )}>
      <div className={clsx(DEFAULT_CONTENT_WIDTH, 'm-auto')}>
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center">
          {/* Desktop Left Button */}
          <NavigationButtons onScrollClick={handleScrollClick} />

          {/* Testimonial Card */}
          <TestimonialCard
            testimonial={currentTestimonial}
            allTestimonials={TESTIMONIALS_DATA}
            activeIndex={activeIndex}
            onScrollClick={handleScrollClick}
          />

          {/* Desktop Right Button */}
          <RightNavigationButton onScrollClick={handleScrollClick} />

          {/* Mobile Navigation Buttons */}
          <MobileNavigationButtons onScrollClick={handleScrollClick} />
        </div>
      </div>
    </section>
  );
};

export { QuotationSection };
